// Demographic signals restored to `adRequest` — CTV co-viewing data that the
// Adaptek provider populates (see the prod audit). Stored as CODES, never
// strings: `gender` is a numeric enum; `ageGroup` is a BITMASK because a single
// request carries a co-viewing SET of age buckets. `wellness`/`habbits` stay
// dropped (0% across every provider). ONE source of truth for PG (Drizzle
// `.$type<>()`), the ClickHouse ingest (via `GENDER_CH_LABEL`), and the frontend.
// Household/co-viewing gender for the request. `Mixed` = a co-viewing household.
export var Gender;
(function (Gender) {
    Gender[Gender["Unknown"] = 0] = "Unknown";
    Gender[Gender["Male"] = 1] = "Male";
    Gender[Gender["Female"] = 2] = "Female";
    Gender[Gender["Mixed"] = 3] = "Mixed";
})(Gender || (Gender = {}));
// Lowercase CH-enum labels (the value stored/compared in ClickHouse).
export const GENDER_CH_LABEL = {
    [Gender.Unknown]: "unknown",
    [Gender.Male]: "male",
    [Gender.Female]: "female",
    [Gender.Mixed]: "mixed",
};
export const genderToCode = (s) => {
    switch ((s ?? "").trim().toLowerCase()) {
        case "male":
            return Gender.Male;
        case "female":
            return Gender.Female;
        case "mixed":
            return Gender.Mixed;
        default:
            return Gender.Unknown;
    }
};
// Ordered age buckets; each maps to a bit. A request may carry several (co-
// viewing), so they OR into one mask. '65+' is reserved for forward-compat
// (not seen in prod yet) — appending buckets is safe, reordering is not.
export const AGE_BUCKETS = [
    "4-11",
    "12-17",
    "18-24",
    "25-34",
    "35-44",
    "45-54",
    "55-64",
    "65+",
];
export const AGE_BUCKET_BIT = Object.fromEntries(AGE_BUCKETS.map((b, i) => [b, 1 << i]));
// A co-viewing set of bucket names -> a single bitmask. Unknown buckets are
// ignored (never throws — ingest must not drop a whole request over one label).
export const ageGroupsToMask = (a) => {
    if (!a)
        return 0;
    let mask = 0;
    for (const b of a)
        mask |= AGE_BUCKET_BIT[String(b).trim()] ?? 0;
    return mask;
};
export const maskToAgeGroups = (mask) => AGE_BUCKETS.filter((b) => (mask & AGE_BUCKET_BIT[b]) !== 0);
//# sourceMappingURL=demographics.js.map